import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Entity, Guard, Result, UniqueEntityID } from '@digibricks/domains';
import { QuestionReleases, QuestionType } from '@module/form';
import { ConfigType } from '../data-config';
import { PracticeSubmissionResult } from './practice-submission-result';
import { ShuffledQuestion } from '../shuffled-question';
import { HomeworkSubmissionResult } from './homework-submission-result';
import { SecurityTracing } from './securityTracing';
import { ExaminationSubmissionResult } from './examination-submission-result';
import { AudioPlayStats } from './audio-play-stats';
import { SubmissionScore } from '../submission-score';
import { BanInformation } from '../ban-information';
import { TimeTakenSubmission } from './time-taken-submission';
import { AssignmentType } from '../assignment-type';
export var Submission = /*#__PURE__*/function (_Entity) {
  _inherits(Submission, _Entity);

  var _super = _createSuper(Submission);

  function Submission() {
    _classCallCheck(this, Submission);

    return _super.apply(this, arguments);
  }

  _createClass(Submission, [{
    key: "attendeeId",
    get: function get() {
      return this.props.attendeeId;
    }
  }, {
    key: "type",
    get: function get() {
      return this.props.type;
    }
  }, {
    key: "submitTime",
    get: function get() {
      return this.props.submitTime;
    }
  }, {
    key: "elapsedTime",
    get: function get() {
      return this.props.elapsedTime;
    }
  }, {
    key: "result",
    get: function get() {
      return this.props.result;
    }
  }, {
    key: "assignmentId",
    get: function get() {
      return this.props.assignmentId;
    }
  }, {
    key: "status",
    get: function get() {
      return this.props.status;
    }
  }, {
    key: "totalQuestions",
    get: function get() {
      return this.props.totalQuestions;
    }
  }, {
    key: "shuffledQuestions",
    get: function get() {
      return this.props.shuffledQuestions;
    }
  }, {
    key: "securityTracings",
    get: function get() {
      return this.props.securityTracings;
    }
  }, {
    key: "audioPlayStats",
    get: function get() {
      return this.props.audioPlayStats;
    }
  }, {
    key: "banInformation",
    get: function get() {
      return this.props.banInformation;
    }
  }, {
    key: "comment",
    get: function get() {
      return this.props.comment;
    }
  }, {
    key: "toJsonObject",
    value: function toJsonObject() {
      return _objectSpread({}, this.props);
    }
  }, {
    key: "hasNotGraded",
    value: function hasNotGraded() {
      var _this$result;

      return ((_this$result = this.result) === null || _this$result === void 0 ? void 0 : _this$result.score) === SubmissionScore["default"].value;
    }
  }, {
    key: "getCorrectAnswers",
    value: function getCorrectAnswers() {
      var _this$result2, _this$result3;

      var numberOfCorrectAnswers = (_this$result2 = this.result) === null || _this$result2 === void 0 ? void 0 : _this$result2.numberOfCorrectAnswers;

      if (typeof numberOfCorrectAnswers === 'number' && Number.isFinite(numberOfCorrectAnswers)) {
        return numberOfCorrectAnswers;
      }

      var score = (_this$result3 = this.result) === null || _this$result3 === void 0 ? void 0 : _this$result3.score;
      return typeof score === 'number' && Number.isFinite(score) ? score : 0;
    }
  }, {
    key: "getTotalQuestionCount",
    value: function getTotalQuestionCount(questions, formRelease) {
      var _formRelease$sections;

      var weightedTotal = QuestionReleases.totalQuestions(questions);

      if (weightedTotal > 0) {
        return weightedTotal;
      }

      if (typeof this.totalQuestions === 'number' && this.totalQuestions > 0) {
        return this.totalQuestions;
      }

      if (formRelease !== null && formRelease !== void 0 && (_formRelease$sections = formRelease.sections) !== null && _formRelease$sections !== void 0 && _formRelease$sections.length) {
        return formRelease.sections.reduce(function (sum, section) {
          var _section$totalQuestio;

          return sum + ((_section$totalQuestio = section.totalQuestion) !== null && _section$totalQuestio !== void 0 ? _section$totalQuestio : 0);
        }, 0);
      }

      return questions.length;
    }
    /**
     * Counts correct answer slots per section.
     * Matching sub-questions and fill-in-blank blanks count as individual items.
     */

  }, {
    key: "getCorrectQuestionsPerSection",
    value: function getCorrectQuestionsPerSection(formRelease, questions, submissionAnswers) {
      if (!formRelease || !(questions !== null && questions !== void 0 && questions.length) || !(submissionAnswers !== null && submissionAnswers !== void 0 && submissionAnswers.length)) {
        return [];
      }

      return formRelease.sections.map(function (section) {
        var questionsInSection = questions.filter(function (q) {
          var _q$sectionId;

          return ((_q$sectionId = q.sectionId) === null || _q$sectionId === void 0 ? void 0 : _q$sectionId.toString()) === section.id.toString();
        });
        return questionsInSection.reduce(function (correctCount, currentQuestion) {
          var matchedAnswer = submissionAnswers.find(function (a) {
            return a.questionId === currentQuestion.id.toString();
          });

          if (!matchedAnswer) {
            return correctCount;
          }

          switch (currentQuestion.type) {
            case QuestionType.SingleChoice:
              return correctCount + Submission.countCorrectSingleChoice(currentQuestion, matchedAnswer);

            case QuestionType.MultipleChoice:
              return correctCount + Submission.countCorrectMultipleChoice(currentQuestion, matchedAnswer);

            case QuestionType.Matching:
              return correctCount + Submission.countCorrectMatchingSlots(currentQuestion, matchedAnswer);

            case QuestionType.FillInBlank:
              return correctCount + Submission.countCorrectFillInBlankSlots(currentQuestion, matchedAnswer);

            default:
              return correctCount;
          }
        }, 0);
      });
    }
  }, {
    key: "getExaminationPreviewMetrics",
    value: function getExaminationPreviewMetrics(formRelease, questions, submissionAnswers) {
      var totalQuestions = this.getTotalQuestionCount(questions, formRelease);
      var correctCount = submissionAnswers !== null && submissionAnswers !== void 0 && submissionAnswers.length ? this.getCorrectQuestionsPerSection(formRelease, questions, submissionAnswers).reduce(function (sum, value) {
        return sum + value;
      }, 0) : 0;
      var incorrectCount = Math.max(0, totalQuestions - correctCount);
      var globalPercent = totalQuestions > 0 ? Math.max(0, Math.min(100, Math.round(correctCount / totalQuestions * 100))) : 0;
      return {
        correctCount: correctCount,
        incorrectCount: incorrectCount,
        totalQuestions: totalQuestions,
        globalPercent: globalPercent
      };
    }
  }, {
    key: "getScorePerSection",
    value: function getScorePerSection(formRelease, submissionAnswers) {
      var _formRelease$sections2;

      if (!(formRelease !== null && formRelease !== void 0 && (_formRelease$sections2 = formRelease.sections) !== null && _formRelease$sections2 !== void 0 && _formRelease$sections2.length) || !submissionAnswers) {
        return [];
      }

      return formRelease.sections.map(function (section) {
        return submissionAnswers.reduce(function (sum, answer) {
          if (answer.sectionId !== section.id.toString()) {
            return sum;
          }

          return sum + Submission.getAnswerEarnedScore(answer);
        }, 0);
      });
    }
  }, {
    key: "getScoreSummary",
    value: function getScoreSummary(params) {
      var _formRelease$sections3, _ref, _this$result4, _this$result5, _this$result6;

      var formRelease = params.formRelease,
          _params$submissionAns = params.submissionAnswers,
          submissionAnswers = _params$submissionAns === void 0 ? [] : _params$submissionAns;
      var scorePerSection = formRelease ? this.getScorePerSection(formRelease, submissionAnswers) : [];
      var totalScoreFromSections = formRelease === null || formRelease === void 0 ? void 0 : (_formRelease$sections3 = formRelease.sections) === null || _formRelease$sections3 === void 0 ? void 0 : _formRelease$sections3.reduce(function (sum, section) {
        var _section$totalScore;

        return sum + ((_section$totalScore = section.totalScore) !== null && _section$totalScore !== void 0 ? _section$totalScore : 0);
      }, 0);
      var totalScore = (_ref = typeof totalScoreFromSections === 'number' && totalScoreFromSections > 0 ? totalScoreFromSections : undefined) !== null && _ref !== void 0 ? _ref : typeof params.totalScore === 'number' && Number.isFinite(params.totalScore) ? params.totalScore : 0;
      var earnedScoreFromAnswers = scorePerSection.reduce(function (sum, score) {
        return sum + score;
      }, 0);
      var hasAnswerScores = submissionAnswers.length > 0;
      var hasValidResultScore = typeof ((_this$result4 = this.result) === null || _this$result4 === void 0 ? void 0 : _this$result4.score) === 'number' && Number.isFinite(this.result.score) && this.result.score !== SubmissionScore["default"].value && this.result.score >= 0;
      var resultScore = Submission.toDisplayScore((_this$result5 = this.result) === null || _this$result5 === void 0 ? void 0 : _this$result5.score); // Prefer answer-level scores when answers are loaded. Using result.score === 0
      // previously hid graded answers and forced 0/total on Practice (and Exam) preview.

      var earnedScore = hasAnswerScores ? earnedScoreFromAnswers : hasValidResultScore ? resultScore : 0;
      var expectationResult = (_this$result6 = this.result) === null || _this$result6 === void 0 ? void 0 : _this$result6.expectationResult;
      var hasExpectationResult = typeof expectationResult === 'number' && Number.isFinite(expectationResult); // If answers are present but still ungraded (sum 0) while the submission result
      // already has a percentage, derive points from that percentage.

      if (earnedScore === 0 && hasExpectationResult && expectationResult > 0 && totalScore > 0 && (!hasValidResultScore || this.result.score === 0)) {
        earnedScore = Math.round(expectationResult / 100 * totalScore);
      } else if (earnedScore === 0 && hasValidResultScore && resultScore > 0 && hasAnswerScores) {
        earnedScore = resultScore;
      }

      var globalPercent = hasExpectationResult ? Math.max(0, Math.min(100, Math.round(expectationResult))) : totalScore > 0 ? Math.max(0, Math.min(100, Math.round(earnedScore / totalScore * 100))) : 0;
      return {
        scorePerSection: scorePerSection,
        totalScore: totalScore,
        earnedScore: earnedScore,
        globalPercent: globalPercent
      };
    }
  }, {
    key: "getResultPercentage",
    value: function getResultPercentage(totalScore) {
      var _this$result7, _this$result8;

      var expectationResult = (_this$result7 = this.result) === null || _this$result7 === void 0 ? void 0 : _this$result7.expectationResult;

      if (typeof expectationResult === 'number' && Number.isFinite(expectationResult)) {
        return Math.max(0, Math.min(100, Math.round(expectationResult)));
      }

      var submissionScore = (_this$result8 = this.result) === null || _this$result8 === void 0 ? void 0 : _this$result8.score;

      if (typeof submissionScore === 'number' && Number.isFinite(submissionScore) && typeof totalScore === 'number' && Number.isFinite(totalScore) && totalScore > 0) {
        return Math.max(0, Math.min(100, Math.round(submissionScore / totalScore * 100)));
      }

      return 0;
    }
  }, {
    key: "getTimeTakenMinutes",
    value: function getTimeTakenMinutes(params) {
      return TimeTakenSubmission.calculateMinutes({
        assignmentDuration: params.assignmentDuration,
        createdAt: this.createdAt,
        submitTime: this.submitTime
      });
    }
  }, {
    key: "isEmptyComment",
    value: function isEmptyComment() {
      return !this.comment || this.comment === '<p></p>' || this.comment === '<p><br></p>';
    }
  }, {
    key: "updateStatus",
    value: function updateStatus(status) {
      this.props.status = status;
      return Result.ok();
    }
  }, {
    key: "updateElapsedTime",
    value: function updateElapsedTime(elapsedTime) {
      this.props.elapsedTime = elapsedTime;
    }
  }, {
    key: "updateComment",
    value: function updateComment(comment) {
      this.props.comment = comment;
    }
  }, {
    key: "updateAudioPlayStats",
    value: function updateAudioPlayStats(audioPlayStats) {
      this.props.audioPlayStats = audioPlayStats;
    }
  }, {
    key: "isStatusSatisfied",
    value: function isStatusSatisfied(status) {
      return this.props.status.id === status;
    }
  }, {
    key: "isSectionAudioPlayBudgetExhausted",
    value: function isSectionAudioPlayBudgetExhausted(submission, audioFile) {
      var _audioFile$rule, _audioFile$rule$numbe, _submission$audioPlay;

      var max = audioFile === null || audioFile === void 0 ? void 0 : (_audioFile$rule = audioFile.rule) === null || _audioFile$rule === void 0 ? void 0 : (_audioFile$rule$numbe = _audioFile$rule.numberOfReplays) === null || _audioFile$rule$numbe === void 0 ? void 0 : _audioFile$rule$numbe.value;
      if (max == null || max === -1) return false;
      var stat = (_submission$audioPlay = submission.audioPlayStats) === null || _submission$audioPlay === void 0 ? void 0 : _submission$audioPlay.find(function (s) {
        return s.audioFileId === audioFile.id.toString();
      });
      return (stat === null || stat === void 0 ? void 0 : stat.getConsumedAudioPlayEventsCount(stat)) >= max;
    }
  }], [{
    key: "create",
    value: function create(props) {
      var guardCollection = [{
        argument: props.id,
        argumentName: 'Id'
      }, {
        argument: props.attendeeId,
        argumentName: 'Attendee Id'
      }, {
        argument: props.assignmentId,
        argumentName: 'Assignment Id'
      }, {
        argument: props.status,
        argumentName: 'Submission Status'
      }, {
        argument: props.type,
        argumentName: 'Submission Type'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(guardCollection);

      if (!guardResult.succeeded) {
        return Result.fail(guardResult.message);
      }

      var submissionSummary = new Submission(props, new UniqueEntityID(props.id));
      submissionSummary.createdAt = props.createdAt;
      return Result.ok(submissionSummary);
    }
  }, {
    key: "fromJson",
    value: function fromJson(data) {
      try {
        var id = data.id,
            attendeeId = data.attendeeId,
            assignmentId = data.assignmentId,
            status = data.status,
            submitTime = data.submitTime,
            type = data.type,
            elapsedTime = data.elapsedTime,
            createdAt = data.createdAt,
            result = data.result,
            shuffledQuestions = data.shuffledQuestions,
            securityTracings = data.securityTracings,
            banInformation = data.banInformation,
            comment = data.comment,
            submissionStartedAt = data.submissionStartedAt;
        var typeProps = ConfigType.create({
          id: type.id,
          name: type.name
        }).getValue();
        var statusProps = ConfigType.create({
          id: status.id,
          name: status.name
        }).getValue();
        var securityTracingsProps = securityTracings && securityTracings.length !== 0 ? securityTracings.map(function (securityTracing) {
          return SecurityTracing.create(_objectSpread({}, securityTracing)).getValue();
        }) : null;
        var banInformationProps = banInformation ? BanInformation.create(_objectSpread({}, banInformation)).getValue() : null;
        var props = {
          id: id,
          attendeeId: attendeeId,
          assignmentId: assignmentId,
          status: statusProps,
          type: typeProps,
          submitTime: submitTime,
          result: result,
          elapsedTime: elapsedTime,
          createdAt: createdAt,
          securityTracings: securityTracingsProps,
          audioPlayStats: data.audioPlayStats ? data.audioPlayStats.map(function (audioPlayStats) {
            return AudioPlayStats.create(audioPlayStats).getValue();
          }) : [],
          banInformation: banInformationProps,
          comment: comment
        };

        if (shuffledQuestions && shuffledQuestions.length !== 0) {
          var results = [];

          var _iterator = _createForOfIteratorHelper(shuffledQuestions),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var shuffledQuestion = _step.value;
              results.push(ShuffledQuestion.fromJson(shuffledQuestion));
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          var resultCombine = Result.combineArray(results);

          if (resultCombine.isFailure) {
            return Result.fail(resultCombine.error);
          }

          props.shuffledQuestions = resultCombine.getValue();
        }

        if (result && result.status) {
          switch (type.id) {
            case AssignmentType.Practice:
              {
                var resultPropsOrError = PracticeSubmissionResult.fromJson(_objectSpread({}, result));

                if (resultPropsOrError.isFailure) {
                  return Result.fail(resultPropsOrError.error);
                }

                props.result = resultPropsOrError.getValue();
                break;
              }

            case AssignmentType.Homework:
              {
                var _resultPropsOrError = HomeworkSubmissionResult.fromJson(_objectSpread({}, result));

                if (_resultPropsOrError.isFailure) {
                  return Result.fail(_resultPropsOrError.error);
                }

                props.result = _resultPropsOrError.getValue();
                break;
              }

            case AssignmentType.Examination:
              {
                var _resultPropsOrError2 = ExaminationSubmissionResult.fromJson(_objectSpread({}, result));

                if (_resultPropsOrError2.isFailure) {
                  return Result.fail(_resultPropsOrError2.error);
                }

                props.result = _resultPropsOrError2.getValue();
                break;
              }
          }
        }

        return this.create(props);
      } catch (error) {
        return Result.fail(error);
      }
    }
  }, {
    key: "fromJsonWithTotalQuestions",
    value: function fromJsonWithTotalQuestions(data) {
      try {
        var id = data.id,
            attendeeId = data.attendeeId,
            assignmentId = data.assignmentId,
            status = data.status,
            submittedTime = data.submittedTime,
            submitedTime = data.submitedTime,
            submitTime = data.submitTime,
            type = data.type,
            elapsedTime = data.elapsedTime,
            createdAt = data.createdAt,
            result = data.result,
            totalQuestions = data.totalQuestions,
            shuffledQuestions = data.shuffledQuestions;
        var typeProps = ConfigType.create({
          id: type.id,
          name: type.name
        }).getValue();
        var statusProps = ConfigType.create({
          id: status.id,
          name: status.name
        }).getValue();
        var props = {
          id: id,
          attendeeId: attendeeId,
          assignmentId: assignmentId,
          status: statusProps,
          type: typeProps,
          submitTime: submitTime,
          result: result,
          elapsedTime: elapsedTime,
          createdAt: createdAt,
          totalQuestions: totalQuestions
        };

        if (result && result.status) {
          var resultPropsOrError = PracticeSubmissionResult.fromJson(_objectSpread({}, result));

          if (resultPropsOrError.isFailure) {
            return Result.fail(resultPropsOrError.error);
          }
        }

        return this.create(props);
      } catch (error) {
        return Result.fail(error);
      }
    }
  }, {
    key: "countCorrectSingleChoice",
    value: function countCorrectSingleChoice(question, answer) {
      return answer.isCorrect(question) ? 1 : 0;
    }
  }, {
    key: "countCorrectMultipleChoice",
    value: function countCorrectMultipleChoice(question, answer) {
      return answer.isCorrect(question) ? 1 : 0;
    }
  }, {
    key: "countCorrectMatchingSlots",
    value: function countCorrectMatchingSlots(question, answer) {
      var _matchingQuestion$cor, _matchingQuestion$sub, _matchingQuestion$sub2;

      var matchingQuestion = question;
      var slotSubQuestionIds = ((_matchingQuestion$cor = matchingQuestion.correctAnswers) === null || _matchingQuestion$cor === void 0 ? void 0 : _matchingQuestion$cor.length) > 0 ? matchingQuestion.correctAnswers.map(function (correctAnswer) {
        return correctAnswer.subQuestionId;
      }) : (_matchingQuestion$sub = (_matchingQuestion$sub2 = matchingQuestion.subQuestions) === null || _matchingQuestion$sub2 === void 0 ? void 0 : _matchingQuestion$sub2.map(function (subQuestion) {
        return subQuestion.id.toString();
      })) !== null && _matchingQuestion$sub !== void 0 ? _matchingQuestion$sub : [];
      return slotSubQuestionIds.reduce(function (count, subQuestionId) {
        var subAnswer = answer.answers.find(function (matchingAnswer) {
          return matchingAnswer.subQuestionId === subQuestionId;
        });

        if (!subAnswer) {
          return count;
        }

        if (typeof matchingQuestion.isCorrect === 'function') {
          var _subAnswer$value;

          return matchingQuestion.isCorrect(subQuestionId, (_subAnswer$value = subAnswer.value) === null || _subAnswer$value === void 0 ? void 0 : _subAnswer$value.answerId) ? count + 1 : count;
        }

        return count;
      }, 0);
    }
  }, {
    key: "countCorrectFillInBlankSlots",
    value: function countCorrectFillInBlankSlots(question, answer) {
      var _question$correctAnsw, _question$answers$map, _question$answers;

      var slotBlankIds = ((_question$correctAnsw = question.correctAnswers) === null || _question$correctAnsw === void 0 ? void 0 : _question$correctAnsw.length) > 0 ? question.correctAnswers.map(function (correctAnswer) {
        return correctAnswer.answerId;
      }) : (_question$answers$map = (_question$answers = question.answers) === null || _question$answers === void 0 ? void 0 : _question$answers.map(function (blankAnswer) {
        return blankAnswer.id.toString();
      })) !== null && _question$answers$map !== void 0 ? _question$answers$map : [];
      return slotBlankIds.reduce(function (count, blankId) {
        var blankAnswer = answer.answers.find(function (fillInBlankAnswer) {
          return fillInBlankAnswer.answerBlankId === blankId;
        });

        if (!blankAnswer) {
          return count;
        }

        if (typeof question.isCorrect === 'function') {
          var _blankAnswer$value;

          return question.isCorrect(blankId, (_blankAnswer$value = blankAnswer.value) === null || _blankAnswer$value === void 0 ? void 0 : _blankAnswer$value.text) ? count + 1 : count;
        }

        return count;
      }, 0);
    }
  }, {
    key: "getAnswerEarnedScore",
    value: function getAnswerEarnedScore(answer) {
      // FIB / Matching groups store points on nested answers.
      if (Array.isArray(answer.answers) && answer.answers.length > 0) {
        return answer.answers.reduce(function (sum, nestedAnswer) {
          return sum + Submission.toDisplayScore(nestedAnswer.score);
        }, 0);
      }

      return Submission.toDisplayScore(answer.score);
    }
  }, {
    key: "toDisplayScore",
    value: function toDisplayScore(score) {
      if (typeof score !== 'number' || !Number.isFinite(score)) {
        return 0;
      } // Default/ungraded sentinel is negative (-1000). Treat missing grades as 0 for display.


      if (score < 0 || score === SubmissionScore["default"].value) {
        return 0;
      }

      return score;
    }
  }]);

  return Submission;
}(Entity);